module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/mlb/hits-3cdc616348a316d226e7d734e6cd5638.svg";